var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "single-crossselling__item",
      class: { "is-open": _vm.isOpen, "is-selected": _vm.isAdded },
      attrs: {
        "data-id": _vm.item.id,
        "data-itemid": _vm.item.data.item.id,
        "data-data": JSON.stringify(_vm.item)
      },
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.toggleOpeningState()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "single-crossselling__indicator single-crossselling__indicator--add",
          class: { "d-none": _vm.isAdded },
          attrs: {
            "data-container": "body",
            "data-html": "true",
            "data-trigger": "hover",
            "data-toggle": "popover",
            "data-placement": "top",
            "data-content": _vm.$translate(
              "ODKleinMore::Template.crosssellerAddItem"
            )
          },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.addItem()
            }
          }
        },
        [
          _c("img", {
            attrs: { src: _vm.pluginPath + "/images/icon-plus.svg" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "single-crossselling__indicator single-crossselling__indicator--remove",
          class: { "d-none": !_vm.isAdded },
          attrs: {
            "data-container": "body",
            "data-html": "true",
            "data-trigger": "hover",
            "data-toggle": "popover",
            "data-placement": "top",
            "data-content": _vm.$translate(
              "ODKleinMore::Template.crosssellerRemoveItem"
            )
          },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.removeItem()
            }
          }
        },
        [
          _c("img", {
            attrs: { src: _vm.pluginPath + "/images/icon-check.svg" }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "single-crossselling__name" }, [
        _vm._v(_vm._s(_vm.item.data.texts.name1))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "single-crossselling__price" }, [
        _vm._v("+" + _vm._s(_vm.item.data.prices.default.price.formatted))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "single-crossselling__info" }, [
        _c("img", { attrs: { src: _vm.pluginPath + "/images/icon-info.svg" } })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "single-crossselling__item-info",
          class: { "is-open": _vm.isOpen }
        },
        [
          _c("hr"),
          _vm._v(" "),
          _c("div", { staticClass: "single-crossselling__item-info-wrapper" }, [
            _c("div", { staticClass: "single-crossselling__img-wrapper" }, [
              _c("img", {
                attrs: {
                  src:
                    _vm.variationImage !== ""
                      ? _vm.variationImage
                      : _vm.item.data.images.all[0].urlMiddle,
                  alt: _vm.item.data.texts.name1
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "single-crossselling__item-data" }, [
              _c("div", { staticClass: "single-crossselling__inner-name" }, [
                _vm._v(_vm._s(_vm.item.data.texts.name1))
              ]),
              _vm._v(" "),
              _c("table", { staticClass: "single-crossselling__table table" }, [
                _c(
                  "tbody",
                  [
                    _vm.colorLabel !== "" && _vm.color !== ""
                      ? [
                          _c(
                            "tr",
                            [
                              _c(
                                "td",
                                {
                                  class: {
                                    "label-with-padding":
                                      _vm.variationSelectData !== null
                                  }
                                },
                                [_vm._v(_vm._s(_vm.colorLabel))]
                              ),
                              _vm._v(" "),
                              _vm.variationSelectData === null
                                ? [_c("td", [_vm._v(_vm._s(_vm.color))])]
                                : [
                                    _vm.variationSelectData !== null
                                      ? _c("td", [
                                          _c(
                                            "div",
                                            { staticClass: "input-unit" },
                                            [
                                              _c(
                                                "select",
                                                {
                                                  staticClass: "custom-select",
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                    },
                                                    change: function($event) {
                                                      return _vm.getVarImage(
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.variationSelectData[12]
                                                    .values,
                                                  function(color) {
                                                    return _c(
                                                      "option",
                                                      {
                                                        domProps: {
                                                          value:
                                                            color.variationId
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(color.name)
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                            ],
                            2
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.sizeLabel !== "" && _vm.size !== ""
                      ? [
                          _c("tr", [
                            _c("td", [_vm._v(_vm._s(_vm.sizeLabel))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(_vm.size))])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.materialLabel !== "" && _vm.material !== ""
                      ? [
                          _c("tr", [
                            _c("td", [_vm._v(_vm._s(_vm.materialLabel))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(_vm.material))])
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "single-crossselling__more-link" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      target: "_blank",
                      href:
                        "/" +
                        _vm.item.data.texts.urlPath +
                        "/a-" +
                        _vm.item.data.item.id,
                      title: _vm.item.data.texts.name1
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$translate(
                            "ODKleinMore::Template.crosssellerMoreInfo"
                          )
                        )
                    )
                  ]
                )
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }